import './style.css';
import { fromLonLat } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import { load, state } from './lib/state';
import { setupMap } from './lib/map';

const origo = fromLonLat([21.62730157317441, 47.504920400338]);
proj4.defs("EPSG:23700", "+proj=somerc +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +towgs84=52.17,-71.82,-13.55,0,0,0,0 +units=m +no_defs");
register(proj4);

/* App */
const snapCoords = [];

const currentUrl = new URL(window.location.href);
const urlParams = currentUrl.searchParams;


setupMap(state);
load();

// get gps data and move _gpsAt around
function gpsLocationFound(pos) {
  const coordinates = fromLonLat([pos.coords.longitude, pos.coords.latitude]);
  let offset = state.fixOffset;
  coordinates[0] += offset[0];
  coordinates[1] += offset[1];
  state.gps = coordinates ? coordinates : origo;
  state.accuracy = pos.coords.accuracy;
}

navigator.geolocation.watchPosition(
  gpsLocationFound,
  function (error) {
    alert(`ERROR: ${error.message}`);
  },
  {
    enableHighAccuracy: true,
  }
);

/*state.onFixOffset(value => {
  let gpsCoord = state._gpsAt.clone().transform(view.getProjection(), 'EPSG:4326').getCoordinates();
  state._gpsAt = fromLonLat([gpsCoord[0] + value[0], gpsCoord[1] + value[1]]);
})*/
